import {
  REQUEST_NOTIFICATIONS,
  RECEIVE_NOTIFICATIONS,
  HIDE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  UPDATE_LAST_SEEN_NOTIFICATION,
  VIEWED_NOTIFICATION,
  REMOVE_SUGGESTION
} from '../actions/constant';

export const initialState = {
  isFetching: true,
  informationNotifications: {
    notifications: [],
    numberOfNewNotifications: 0,
    totalCount: 0
  },
  notificationsWithActions: [],
  suggestions: [],
  organisationId: null
};

function getReceivedNotifications(state, action) {
  if (action.organisationId !== state.organisationId) {
    // If we have switch of organisation ==> Reset of state for this organisation
    return {...state, isFetching: false, ...action.notifications, organisationId: action.organisationId};
  }

  // Only add newest notifications, because we want to locally keep the information "viewed" state of the old notifications
  const oldInformationNotifications = state.informationNotifications.notifications;
  const oldInformationNotificationsIds = oldInformationNotifications.map(
    oldInformationNotification => oldInformationNotification.notificationId
  );
  const receivedNotifications = action.notifications;
  receivedNotifications.informationNotifications.notifications = receivedNotifications.informationNotifications.notifications
    .filter(notification => !oldInformationNotificationsIds.includes(notification.notificationId))
    .concat(oldInformationNotifications);
  return {...state, isFetching: false, ...receivedNotifications};
}

export default function notifications(state = initialState, action = undefined) {
  switch (action.type) {
    case REQUEST_NOTIFICATIONS:
      return {...state, isFetching: true};
    case RECEIVE_NOTIFICATIONS:
      return getReceivedNotifications(state, action);
    case HIDE_NOTIFICATION: {
      const modifiedList = state.notificationsWithActions
        .map(notification => (
          notification.notificationId === action.notificationId ?
            ({...notification, isHidden: true}) :
            notification
        ));

      return {...state, notificationsWithActions: modifiedList};
    }

    case REMOVE_NOTIFICATION: {
      const filteredNotificationsList = state.notificationsWithActions
        .filter(notification => notification.notificationId !== action.notificationId);
      return {...state, notificationsWithActions: filteredNotificationsList};
    }

    case VIEWED_NOTIFICATION: {
    // Set existing notification to 'viewed'
      const modifiedState = {...state};
      modifiedState.informationNotifications.notifications
        .find(notification => notification.notificationId === action.notificationId)
        .viewed = true;
      return {...modifiedState};
    }

    case UPDATE_LAST_SEEN_NOTIFICATION: {
      const modifiedState = {...state};
      modifiedState.informationNotifications.numberOfNewNotifications = 0;
      return {...modifiedState};
    }

    case REMOVE_SUGGESTION: {
      const {invitationId} = action.payload;
      const suggestions = state.suggestions.filter(el => el.invitationId !== invitationId);
      return {
        ...state,
        suggestions
      };
    }

    default:
      return state;
  }
}
